import type { FC } from 'react'

import './style.scss'

import clsx from 'clsx'

interface StatItem {
	color: string
	title: string
	value: string
}

// TODO: rewrite semantically to dl, and use module
const StatisticList: FC<{
	className?: string
	statistics: StatItem[]
}> = ({ className = '', statistics }) => (
	<div className={clsx('statistic-list', className)}>
		{statistics.map(item => (
			<div className='statistic-list-item' key={item.title}>
				<div className='statistic-list-item-label text-page semi-bold'>
					<div
						className='status'
						style={{ backgroundColor: `${item.color}` }}
					/>
					{item.title}
				</div>
				<div className='statistic-list-item-value text-page semi-bold'>
					{item.value}
				</div>
			</div>
		))}
	</div>
)

export default StatisticList
